import React from "react";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";

function InputNumber(props) {
	const { handleChange, value = 0, data } = props;
	const { label, required, id, tooltip = "" } = data;

	return (
		<TextField
			fullWidth
			label={label}
			type="number"
			name={id}
			value={value}
			onChange={handleChange}
			helperText={tooltip}
			InputLabelProps={{
				shrink: true,
			}}
			required={required}
		/>
	);
}

function InputMoneyCustom(props) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			thousandSeparator
			isNumericString
			prefix="$"
		/>
	);
}

function MoneyTextField(props) {
	const { handleChange, value, data } = props;
	const { label, id, required, tooltip = "" } = data;
	return (
		<TextField
			fullWidth
			label={label}
			value={value}
			onChange={handleChange}
			name={id}
			required={required}
			InputProps={{ inputComponent: InputMoneyCustom }}
			tooltip={tooltip}
		/>
	);
}

export default function CustomNumberField(props) {
	const {
		data: { isMoney = false },
	} = props;
	return isMoney ? <MoneyTextField {...props} /> : <InputNumber {...props} />;
}
